import { useCustomParams } from "@/hooks/useCustomParams";
import { useDebounce } from "@/hooks/useDebounce";
import { FieldVariant, HorizontalFlex, Space } from "@enxcs/dap-ui-stratos";
import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { SearchContainer, StyledSearchTrigger } from "./Search.styles";

interface PropsTypes {
  onSearch: (text: string) => void;
}

const SearchSmartDebrief: FC<PropsTypes> = ({ onSearch }) => {
  const { searchTerm } = useCustomParams();
  const [filterKey, setFilterKey] = useState(searchTerm);

  const inputRef = useRef<HTMLInputElement | null>(null);

  const debouncedFilterKey = useDebounce(filterKey);

  const { t } = useTranslation();

  useEffect(() => {
    onSearch(debouncedFilterKey);
  }, [debouncedFilterKey, onSearch]);

  useEffect(() => {
    function handleKeyDown(this: HTMLInputElement, e: globalThis.KeyboardEvent) {
      if (e.key === "Enter") {
        if (e.target && "value" in e.target) {
          onSearch(e.target.value as string);
        }
      }
      if (e.key === "Escape") {
        this.blur();
      }
    }

    const input = inputRef.current;

    input?.addEventListener("keydown", handleKeyDown);

    return () => input?.removeEventListener("keydown", handleKeyDown);
  }, [onSearch]);

  return (
    <HorizontalFlex $justify="flex-end" $padTop={Space.V40}>
      <SearchContainer>
        <StyledSearchTrigger
          value={filterKey}
          placeholder={t("buttons.search")}
          clearTitle={t("buttons.clearAll")}
          role="search"
          id="search"
          qa="search"
          onChange={setFilterKey}
          variant={FieldVariant.COMPACT}
          elementRef={inputRef}
        />
      </SearchContainer>
    </HorizontalFlex>
  );
};

export default SearchSmartDebrief;
